<template>
    <b-container>
      <b-row class="mt-2">
        <b-col md="8" offset-md="2">
            <b-row class="mb-2">
                <b-col md="5" >
                    <b-input-group>
                        <b-form-input v-model="filter" placeholder="Type to Search" size="sm" />
                        <b-input-group-append>
                        <b-btn :disabled="!filter" @click="filter = ''"  size="sm">Clear</b-btn>
                        </b-input-group-append>
                    </b-input-group>
                    
                </b-col>
                <b-col></b-col>
                <b-col style="font-size:0.875rem;float:right;"><b>Total Applications:</b> {{totalRows}}
                
                    <!-- <b-form-group horizontal label="Sort" class="mb-0" label-size="sm" label-cols="2">
                    <b-input-group>
                        <b-form-select v-model="sortBy" :options="sortOptions"  size="sm">
                        <option slot="first" :value="null">-- none --</option>
                        </b-form-select>
                        <b-input-group-append>
                        <b-form-select :disabled="!sortBy" v-model="sortDesc"  size="sm">
                            <option :value="false">Asc</option>
                            <option :value="true">Desc</option>
                        </b-form-select>
                        </b-input-group-append>
                    </b-input-group>
                    </b-form-group> -->
                </b-col>                      
            </b-row>
            <b-table show-empty head-variant="dark"
                stacked="md"
                bordered
                striped
                :items="applications"
                :fields="fields"
                :current-page="currentPage"
                :per-page="perPage"
                :filter="filter"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                style="font-size:12px"
                @filtered="onFiltered"   
            >  
                <template slot="actions" slot-scope="row">
                    <b-button variant="link" size="sm" @click.stop="viewApplication(row.item, row.index, $event.target)" 
                        class="mr-1 pt-0 pb-0" v-b-tooltip.hover title="View Guard Details">
                        <i class="fa fa-eye" style="font-size:16px;color:green"></i>
                    </b-button>                     
                </template>
                <template slot="pay" slot-scope="row">
                    <b-button variant="link" size="sm" @click.stop="pay(row.item, row.index, $event.target)" 
                        class="mr-1 pt-0 pb-0" v-b-tooltip.hover title="Pay Registration Fees" v-if="row.item.payment_status == 'Unpaid'">
                        REGISTRATION FEES
                    </b-button>                     
                </template>
            </b-table>
            <b-row>
                <b-col md="8" class="my-1">
                    <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0"  size="sm"/>
                </b-col>
                <b-col md="4" class="my-1">
                    <b-form-group horizontal label="Per page" class="mb-0" label-size="sm" :label-cols="6">
                    <b-form-select :options="pageOptions" v-model="perPage"  size="sm" />
                    </b-form-group>
                </b-col>
            </b-row>

        </b-col>
      </b-row>
    </b-container>
</template>

<script>
import apis from "@/apis";
const months = [
  "JAN",
  "FEB",
  "MAR",
  "APR",
  "MAY",
  "JUN",
  "JUL",
  "AUG",
  "SEP",
  "OCT",
  "NOV",
  "DEC"
];
export default {
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields.filter(f => f.sortable).map(f => {
        return { text: f.label, value: f.key };
      });
    }
  },
  data() {
    return {
      applications: [],
      fields: [
        
        { key: "BoardName", label: "Board Name", sort: true },
        { key: "ExemptionApplicationNo", label: "Application No", sort: true },
        { key: "ExemptionApplicationDate", label: "Date", sort: true , formatter: "convertDateFormat" },
        //{ key: "employerName", label: "Employer Name", sort: true },
        { key: "TotalEmployers", label: "Total Employers" },
        { key: "TotalGuards", label: "Total Guards" },
        { key: "ApplicationStatus", label: "status" },
        { key: "actions", label: "-" },
        { key: "pay", label: "Payment" }
      ],
      showDismissibleAlert: false,
      variant: "success",
      alertText: "",
      isLoading: false,
      show: true,
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      pageOptions: [5, 10, 15, 20, 50],
      sortBy: null,
      sortDesc: false,
      filter: null
    };
  },
  methods: {
    convertDateFormat(inDate) {
      //return indate.split("T")[0];
      let dbDateTime = new Date(inDate);
      if (dbDateTime.getFullYear() == 1) {
        return null;
      }

      let formattedDate =
        dbDateTime.getDate() +
        "-" +
        months[dbDateTime.getMonth()] +
        "-" +
        dbDateTime.getFullYear();
      return formattedDate;
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    viewApplication(item,index,target){
        this.$router.push({name:'ViewExemptApplication',params:{"applicationId": item.ExemptionApplicationID}});
    },
    pay(item,index,target){
        this.$router.push({name:"RegistrationFeesPmt",params:{"applicationId": item.ExemptionApplicationID}});
    },
    getApplicationList() {
      var userinfo = this.$store.getters.loggedUser;
      let promise = apis.GetExemptionApplicationList_ByAgencyId(userinfo.UserId); 
      
      promise
        .then(response => {
         
            this.applications = response.body;
            this.totalRows = this.guards.length;
          
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
    }
  },
  created(){
    this.getApplicationList();
  },
  mounted()
  {
    this.getApplicationList();
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/ApplyForExemption/ExemptionList.vue